import { AbstractDictionary } from "./AbstractDictionary";
export class DicGoalCategory extends AbstractDictionary {
  static NAME = "tsadv$DicGoalCategory";
}
export type DicGoalCategoryViewName =
  | "_base"
  | "_local"
  | "_minimal"
  | "dicGoalCategory-browse"
  | "dicGoalCategory.browse";
export type DicGoalCategoryView<
  V extends DicGoalCategoryViewName
> = V extends "_base"
  ? Pick<
      DicGoalCategory,
      | "id"
      | "langValue"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "langValue1"
      | "description1"
      | "langValue2"
      | "description2"
      | "langValue3"
      | "description3"
      | "langValue4"
      | "description4"
      | "langValue5"
      | "description5"
      | "startDate"
      | "endDate"
      | "code"
      | "isSystemRecord"
      | "active"
      | "isDefault"
      | "order"
    >
  : V extends "_local"
  ? Pick<
      DicGoalCategory,
      | "id"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "langValue1"
      | "description1"
      | "langValue2"
      | "description2"
      | "langValue3"
      | "description3"
      | "langValue4"
      | "description4"
      | "langValue5"
      | "description5"
      | "startDate"
      | "endDate"
      | "code"
      | "isSystemRecord"
      | "active"
      | "isDefault"
      | "order"
    >
  : V extends "_minimal"
  ? Pick<DicGoalCategory, "id" | "langValue">
  : V extends "dicGoalCategory-browse"
  ? Pick<
      DicGoalCategory,
      | "id"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "langValue1"
      | "description1"
      | "langValue2"
      | "description2"
      | "langValue3"
      | "description3"
      | "langValue4"
      | "description4"
      | "langValue5"
      | "description5"
      | "startDate"
      | "endDate"
      | "code"
      | "isSystemRecord"
      | "active"
      | "isDefault"
      | "order"
      | "company"
    >
  : V extends "dicGoalCategory.browse"
  ? Pick<
      DicGoalCategory,
      | "id"
      | "company"
      | "langValue1"
      | "order"
      | "langValue2"
      | "langValue3"
      | "langValue4"
      | "langValue5"
      | "code"
      | "isSystemRecord"
      | "startDate"
      | "endDate"
    >
  : never;
